import {
  FirestoreTimestamp,
  mapQuizSessionWriteToDb,
  QuizSessionDb,
  quizSessionWriteSchema,
  QuizTimedMode,
  type QuizSessionWrite,
} from '@cp/model';
import {addDoc, DocumentReference, serverTimestamp} from 'firebase/firestore';
import getQuizSessionCollection from './getQuizSessionCollection';

export default async function createQuizSessionDoc(
  uid: string,
  payload: QuizSessionWrite,
): Promise<DocumentReference<QuizSessionDb>> {
  const parsed = quizSessionWriteSchema.parse({
    ...payload,
    timedMode: payload.timedMode ?? QuizTimedMode.PRACTICE,
    count: payload.count ?? 10,
  });
  const col = getQuizSessionCollection(uid);
  const docData = mapQuizSessionWriteToDb(parsed, serverTimestamp() as unknown as FirestoreTimestamp);

  return addDoc(col, docData);
}
